import React from "react";
import "./PesonalizedLectureLayout.scss";
import { useCourse } from "context/context";
import LectureInnerLayout from "./PesonalizedLectureInnerLayout";
// import { RiBook3Line } from "react-icons/ri";
// import { SiGoogletranslate } from "react-icons/si";
function LectureLayout() {
    const { course } = useCourse();
    const isLoading = !course?.courseName;
    return (
        <div className="dashboard lecture_page">
            {/* <div className="dashboard_banner spacing container">
        <div className="container">
          <div className="content">
            <h3>Lectures</h3>
            <p>
              Sed ut perspiciatis unde omnis iste natus error sit voluptatem
              accusantium doloremque laudantium, totam rem aperiam.
            </p>

            <div className="button_wrap">
                            <button className="button">
                                <SiGoogletranslate />
                                HIndi-English
                            </button>
                            <button className="button">
                                <RiBook3Line /> 10 subjects
                            </button>
                        </div>
          </div>
        </div>
      </div> */}
            <div className="dashboard_banner container text_banner">
                <div className="container">
                    <h3 className="lecturetext hide-on-mobile">
                        Personalized Lectures
                    </h3>
                    <h3 className="lecturetext show-on-mobile">
                        Personalized Lectures
                    </h3>
                </div>
            </div>

            <LectureInnerLayout />
        </div>
    );
}

export default LectureLayout;
